import React, { memo } from 'react';
import classNames from 'classnames';
import cls from '../MassActionsPanel.module.css';
import { useTypeBlock } from './useTypeBlock';
import { useTranslation } from 'react-i18next';

export const TypeBlock = memo(({ setActiveSelect, activeSelect }) => {
    const { changeType } = useTypeBlock(setActiveSelect);
    const { t } = useTranslation();

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                if (activeSelect === 'type') {
                    setActiveSelect('');
                } else {
                    setActiveSelect('type');
                }
            }}
            className={cls.select}
        >
            <span>{t('TypeBlock.TypeBtn.text')}</span>
            <div
                className={classNames(cls.svgWrapper, {
                    [cls.active]: activeSelect === 'type',
                })}
            >
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4.95316 6.33337L3.95316 7.33337L8.00003 11.3802L12.0469 7.33337L11.0469 6.33337L8.00003 9.38025L4.95316 6.33337Z"
                        fill="white"
                    />
                </svg>
            </div>
            <div
                className={classNames(
                    cls.actionsGroupList,
                    {
                        [cls.activeList]: activeSelect === 'type',
                    },
                    cls.firstItem
                )}
            >
                <div
                    onClick={(e) => changeType(e, 'labor')}
                    className={classNames(cls.listItem, cls.listTypeItem)}
                >
                    <div className={classNames(cls.listItemIcon, cls.labor)}>
                        {t('TypeBlock.labor.FirstLetter.text')}
                    </div>
                    {t('TypeBlock.labor.text')}
                </div>
                <div
                    onClick={(e) => changeType(e, 'material')}
                    className={classNames(cls.listItem, cls.listTypeItem)}
                >
                    <div className={classNames(cls.listItemIcon, cls.material)}>
                        {t('TypeBlock.material.FirstLetter.text')}
                    </div>
                    {t('TypeBlock.material.text')}
                </div>
                <div
                    onClick={(e) => changeType(e, 'machinery')}
                    className={classNames(cls.listItem, cls.listTypeItem)}
                >
                    <div className={classNames(cls.listItemIcon, cls.machinery)}>
                        {t('TypeBlock.machinery.FirstLetter.text')}
                    </div>
                    {t('TypeBlock.machinery.text')}
                </div>
                <div
                    onClick={(e) => changeType(e, 'shipping')}
                    className={classNames(cls.listItem, cls.listTypeItem)}
                >
                    <div className={classNames(cls.listItemIcon, cls.shipping)}>
                        {t('TypeBlock.shipping.FirstLetter.text')}
                    </div>
                    {t('TypeBlock.shipping.text')}
                </div>
            </div>
        </button>
    );
});
